<template>
  <div class="alertes">
    <transition-group name="fade" tag="div">
      <div v-for="alt in alertes" :key="alt.id">
        <router-link v-if="alt.to" :to="alt.to">
          <div @click="clicked(alt)" class="alerte">
            <div class="moyenCadrePhoto">
              <Photo :profile="alt.profile" :pic="alt.profile.mainPicture" thumb />
            </div>

            <div class="droite">
              <h3>{{ alt.profile.pseudo }}, {{ alt.profile.age }} ans</h3>
              <div class="alertIcon">
                <img :src="alt.icon" />
                <div>{{ alt.text }}</div>
                <img :src="alt.icon" />
              </div>
            </div>
          </div>
        </router-link>

        <a v-if="alt.clicked" href="#" @click.prevent="alt.clicked">
          <div @click="clicked(alt)" class="alerte">
            <div class="moyenCadrePhoto">
              <Photo :profile="alt.profile" :pic="alt.profile.mainPicture" thumb />
            </div>

            <div class="droite">
              <h3>{{ alt.profile.pseudo }}, {{ alt.profile.age }} ans</h3>
              <div class="alertIcon">
                <img :src="alt.icon" />
                <div>{{ alt.text }}</div>
                <img :src="alt.icon" />
              </div>
            </div>
          </div>
        </a>
      </div>
    </transition-group>
  </div>
</template>

<script>
import Photo from "@/components/profile/Photo";
import Vue from "vue";

export default {
  name: "Alertes",
  components: { Photo },

  data() {
    return {
      currentID: 0,
      alertes: [],
      max: 5,
      delaying: false
    };
  },

  mounted: function() {
    this.max = Math.floor(window.innerWidth / 250);
    Vue.prototype.$alert = this;
  },

  methods: {
    flash(profile) {
      this.$alert.generate({
        profile: profile,
        text: "Vient de flasher sur vous !",
        icon: "/assets/icons_" + this.$store.state.iconTheme + "/flash.png",
        to: {
          name: "Profil",
          query: {
            p: profile.pseudo
          }
        }
      });
    },

    visit(profile) {
      this.$alert.generate({
        profile: profile,
        text: "Visite actuellement votre profil...",
        icon: "/assets/icons_" + this.$store.state.iconTheme + "/visite.png",
        to: {
          name: "Profil",
          query: {
            p: profile.pseudo
          }
        }
      });
    },

    message(profile) {
      this.$alert.generate({
        profile: profile,
        text: "Viens de vous envoyer un message !",
        icon: "/assets/icons_" + this.$store.state.iconTheme + "/unread.png",
        to: {
          name: "Messagerie",
          query: {
            id: profile.id
          }
        }
      });
    },

    screenShare(profile) {
      this.$alert.generate({
        profile: profile,
        text: "Souhaite visionner votre écran",
        icon: "/assets/icons/spy.png",
        clicked: () => {
          this.$rtc.shareScreen(profile);
        }
      });
    },

    generate: function(alt) {
      const thisObj = this;

      // if too many alerts are displayed, wait and try again later to make sure other alerts dissipated
      if (this.alertes.length >= this.max) {
        setTimeout(() => {
          this.generate(alt);
        }, 3000);
        return;
      }

      // Minimum 1 second between 2 alerts
      if (this.delaying) {
        setTimeout(() => {
          this.generate(alt);
        }, 1000);
        return;
      }

      this.delaying = true;
      alt.id = this.currentID++;
      this.alertes.splice(0, 0, alt);
      setTimeout(() => {
        this.delaying = false;
      }, 1000);

      setTimeout(() => {
        const index = thisObj.alertes.findIndex(elt => elt.id === alt.id);
        thisObj.alertes.splice(index, 1);
      }, 5000);
    },

    clicked: function(alt) {
      const index = this.alertes.findIndex(elt => elt.id === alt.id);
      this.alertes.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.alertes {
  position: fixed;
  z-index: 200000;
  bottom: 20px;
  right: 20px;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  grid-gap: 20px;
}

.alertes > div {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  grid-gap: 20px;
}

.alerte {
  border: #b3e0ff 1px solid;
  box-shadow: 0px 0px 10px 5px #92d0f9;
  width: 320px;
  height: 130px;
  background-color: white;
  padding: 5px;
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-gap: 5px;
  cursor: pointer;

  h3 {
    color: $theme_color;
    margin: 0;
    font-size: 16px;
  }

  .droite {
    display: grid;
    grid-template-rows: min-content 1fr;
    align-items: center;
    .alertIcon {
      display: grid;
      grid-template-columns: min-content 1fr min-content;
      justify-items: center;
      justify-content: center;
      text-align: center;
      margin: 5px;
    }
  }
}
</style>
